import React from 'react';

import QueryDetails from './new-query-details';
import DriverDetails from './new-driver';
import CompanyDetails from './new-company';
import FreightDetails from './freight-details';
import VehicleDetails from './new-vehicle';
import QueryComments from './query-comments';
import QueryCertifiedComments from './query-certified-comments';
import { SkeletonTheme } from 'react-loading-skeleton';

import PrintQueryButton from './print-query-button';
import styles from './styles.css';

function HistoryQueryDetails({
  query = {},
  history = {},
  showDriver = Boolean(query && query.driverId),
  showCompany = Boolean(query && query.companyId),
  showCab = Boolean(query && query.cabId),
  showTow = Boolean(query && query.towId),
  showTow2 = Boolean(query && query.towId2),
  showTow3 = Boolean(query && query.towId3),
  ...props
}) {
  return <div className={styles.detailsContainer} {...props}>

    <PrintQueryButton shown queryId={history.queryId} />

    <SkeletonTheme color="#bbb" highlightColor="#ddd" >
      <div
        className={styles.columnsWrapper}
        style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
      >
        <div><QueryDetails query={query} /></div>
        {showDriver && <div><DriverDetails history={history} /></div>}
        {showCompany && <div><CompanyDetails history={history} /></div>}
        {
          showCab && (
            <div><VehicleDetails title="Cavalo" historyPrefix="cab" history={history} /></div>
          )
        }
        {
          showTow && (
            <div><VehicleDetails title="1º Reboque" historyPrefix="tow" history={history} /></div>
          )
        }
        {
          showTow2 && (
            <div><VehicleDetails title="2º Reboque" historyPrefix="tow2" history={history} /></div>
          )
        }
        {
          showTow3 && (
            <div><VehicleDetails title="3º Reboque" historyPrefix="tow3" history={history} /></div>
          )
        }
        <div><FreightDetails query={query} /></div>

        <div><QueryComments query={query} /></div>
        <div><QueryCertifiedComments query={query} /></div>
      </div>
    </SkeletonTheme>
  </div>;
}

export default HistoryQueryDetails;
